#import "./workOrderInfo.gql"

query GetWorkOrders($searchText: String, $searchCategory: String, $filters: WorkOrderFiltersInput, $limit: Int) {
  workOrders(searchText: $searchText, searchCategory: $searchCategory, filters: $filters, limit: $limit)
    @connection(key: "workOrders")
  {
    ...workOrderInfo
  }
}

query GetWorkOrder($id: ID!) {
  workOrder(id: $id) {
    ...workOrderInfo
    workBlocks {
      id
      startsAt
      endsAt
      teardownTimeLabel
      teardownTimeDuration
      line {
        id
        name
        active
      }
      overlappingPlannedBreaks {
        duration
        plannedBreakName
      }
    }
  }
}

query GetWorkOrderFiltered($id: ID!, $searchText: String, $searchCategory: String, $filters: WorkOrderFiltersInput) {
  workOrderFiltered(id: $id, searchText: $searchText, searchCategory: $searchCategory, filters: $filters) {
    filteredOut
  }
}

mutation DeleteWorkOrder($id: ID!) {
  deleteWorkOrder(id: $id) {
    workOrder {
      id
    }
  }
}

mutation UnscheduleWorkOrder($id: ID) {
  unscheduleWorkOrder(id: $id) {
    workOrder {
      ...workOrderInfo
    }
  }
}

mutation UpdateWorkOrder($id: ID!, $flag: String, $notes: String) {
  updateWorkOrder(id: $id, flag: $flag, notes: $notes) {
    workOrder {
      ...workOrderInfo
    }
  }
}

subscription OnWorkOrderCreated {
  workOrderCreated {
    workOrder {
      ...workOrderInfo
    }
  }
}

subscription OnWorkOrderUpdated {
  workOrderUpdated {
    workOrder {
      ...workOrderInfo
    }
  }
}

subscription OnWorkOrderDeleted {
  workOrderDeleted {
    workOrder {
      id
    }
  }
}
